import { cloneDeep } from 'lodash-es';

import { IGroupFilterItem, IGroupFilters } from '@/bundles/GroupFilters/helpers/getDefaultFiltersObj';
import { FREE_ISOCHRONE_FILTER_KEY, MARKER_ISOCHRONE_FILTER_KEY } from '@/bundles/Map/constants';
import {
  IFilterIsochroneOptions,
  IFilterLandSizeRangeOptions,
  IFilterSalePriceRangeOptions
} from '@/bundles/GroupFilters/interfaces/IStoreFilterItem';

const keysWithUnit = ['sales_price', 'land_size'];
const isochroneKeys = [MARKER_ISOCHRONE_FILTER_KEY, FREE_ISOCHRONE_FILTER_KEY];
const keysToHandle = [...keysWithUnit, ...isochroneKeys]; // keys without source

export const mapNewFiltersWithAdditionalKeysForApi = (mappedFilters: Record<string, any>, groupId: string, filters: IGroupFilters) => {
  if (!Object.keys(mappedFilters).some(filterKey => keysToHandle.some(key => filterKey.endsWith(key)))) {
    return mappedFilters;
  }

  const mappedFiltersWithAdditionalKeys = cloneDeep(mappedFilters);

  for (const key of keysToHandle) {
    const keyFilterEntry = Object.keys(mappedFiltersWithAdditionalKeys).find((filterKey) => filterKey.endsWith(key));

    if (!keyFilterEntry) {
      continue;
    }

    if (keysWithUnit.includes(key)) {
      const filterOptions = filters[groupId][keyFilterEntry]?.options as IFilterLandSizeRangeOptions | IFilterSalePriceRangeOptions | undefined;
      mappedFiltersWithAdditionalKeys[`${keyFilterEntry}_unit`] = filterOptions?.unit;
    }

    if (isochroneKeys.includes(key)) {
      const filterOptions = filters[groupId][keyFilterEntry]?.options as IFilterIsochroneOptions | undefined;
      mappedFiltersWithAdditionalKeys[`${keyFilterEntry}_routing`] = filterOptions?.routingProfile;
      mappedFiltersWithAdditionalKeys[`${keyFilterEntry}_contour_type`] = filterOptions?.contourType;
      mappedFiltersWithAdditionalKeys[`${keyFilterEntry}_contour`] = filterOptions?.contour;
    }
  }

  return mappedFiltersWithAdditionalKeys;
}

export const mapNewFiltersWithAdditionalKeysForFilterSet = (mappedGroupFilters: { name: string; value: any }[], filtersGroup: IGroupFilterItem) => {
  const isNeedToHandleKeys = mappedGroupFilters.some(({ name }) => keysToHandle.some(key => name.endsWith(key)));

  if (!isNeedToHandleKeys) {
    return mappedGroupFilters;
  }

  const mappedGroupFiltersWithAdditionalKeys = cloneDeep(mappedGroupFilters);

  for (const key of keysToHandle) {
    const keyFilter = mappedGroupFiltersWithAdditionalKeys.find(filter => filter.name.endsWith(key));

    if (!keyFilter) { continue; }

    if (keysWithUnit.includes(key)) {
      const filterOptions = filtersGroup[keyFilter.name]?.options as IFilterLandSizeRangeOptions | IFilterSalePriceRangeOptions | undefined;
      mappedGroupFiltersWithAdditionalKeys.push({
        name: `${keyFilter.name}_unit`,
        value: filterOptions?.unit,
      });
    }

    if (isochroneKeys.includes(key)) {
      const filterOptions = filtersGroup[keyFilter.name]?.options as IFilterIsochroneOptions | undefined;
      mappedGroupFiltersWithAdditionalKeys.push({
        name: `${keyFilter.name}_routing`,
        value: filterOptions?.routingProfile,
      });
      mappedGroupFiltersWithAdditionalKeys.push({
        name: `${keyFilter.name}_contour_type`,
        value: filterOptions?.contourType,
      });
      mappedGroupFiltersWithAdditionalKeys.push({
        name: `${keyFilter.name}_contour`,
        value: filterOptions?.contour,
      });
    }
  }

  return mappedGroupFiltersWithAdditionalKeys;
}
